import React, { useEffect, useState } from "react";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import { Table, Button, Container, Alert } from "react-bootstrap";
import HistoryModal from "./modals/HistoryModal";
import PaginationComponent from "./PaginationComponent";
import "toastr/build/toastr.min.css";
import { FaAngleUp, FaAngleDown, FaHistory } from "react-icons/fa";
import { formatDateTime } from "./utils";
import { useAuth } from "../context/AuthContext"; // ✅ Импорт контекста авторизации

function PartnerOrders() {
  const { uniqueId } = useParams(); // Получаем уникальный ID партнера
  const [orders, setOrders] = useState([]); // Заказы партнера
  const [filteredPayments, setFilteredPayments] = useState([]); // История платежей
  const [totalSum, setTotalSum] = useState(0); // Общая сумма заказов
  const [promoCode, setPromoCode] = useState(0); // Промокод
  const [partnerName, setName] = useState(0); // Имя партнера
  const [partnerEmail, setEmail] = useState(0); // Email партнера
  const [partnerAddress, setPartnerAddress] = useState(""); // Адрес партнера
  const [dateAdded, setPartnerDateAdded] = useState(""); // Дата добавления партнера
  const [payoutPercentage, setPayoutPercentage] = useState(0); // Процент выплат
  const [totalPaidOrders, setTotalPaidOrders] = useState(0); // Количество оплаченных заказов
  const [totalUnpaidOrders, setTotalUnpaidOrders] = useState(0); // Количество неоплаченных заказов
  const [partnerStatus, setStatusPartners] = useState(""); // Статус партнера
  const [showHistoryModal, setShowHistoryModal] = useState(false); // Модальное окно для истории выплат
  const [paymentHistory, setPaymentHistory] = useState([]); // История платежей
  const [partnerBirthday, setPartnerBirthday] = useState(""); // Дата рождения партнера
  const [partnerPhone, setPartnerPhone] = useState(""); // Телефон партнера
  const [partnerNote, setPartnerNote] = useState(""); // Заметка о партнере
  const [paidSum, setPaidSum] = useState(0); // Сумма оплаченных заказов
  const [unpaidSum, setUnpaidSum] = useState(0); // Сумма неоплаченных заказов
  const { user, isAuthenticated, hasRole } = useAuth();

  // Пагинация для заказов
  const [ordersPerPage, setOrdersPerPage] = useState(10); // Количество заказов на странице
  const [ordersCurrentPage, setOrdersCurrentPage] = useState(1); // Текущая страница для заказов
  const ordersIndexOfLastItem = ordersCurrentPage * ordersPerPage;
  const ordersIndexOfFirstItem = ordersIndexOfLastItem - ordersPerPage;

  // Пагинация для истории платежей
  // Фильтрация заказов (оплаченные и неоплаченные)
  // const filteredOrders = showPaidOrders
  //   ? orders
  //   : orders.filter((order) => !order.is_paid);

  const filteredOrders = orders.map((order) => ({
    ...order,
    className: order.is_paid ? "table-success" : "",
  }));

  const currentOrders = filteredOrders.slice(
    ordersIndexOfFirstItem,
    ordersIndexOfLastItem
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterDates, setFilterDates] = useState({ from: "", to: "" });
  const [dateInputs, setDateInputs] = useState({ from: "", to: "" }); // Состояние для полей даты
  // Количество элементов на странице для платежей
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPayments = filteredPayments.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Сортировка заказов
  const [ordersSortField, setOrdersSortField] = useState("order_date"); // Поле сортировки
  const [ordersSortOrder, setOrdersSortOrder] = useState("desc"); // Порядок сортировки (desc/asc)

  const [paymentsSortField, setPaymentsSortField] = useState("payment_date"); // Поле сортировки для истории платежей
  const [paymentsSortOrder, setPaymentsSortOrder] = useState("desc"); // Порядок сортировки истории платежей

  const apiUrl = process.env.REACT_APP_API_URL;

  const formattedBirthday = partnerBirthday
    ? (() => {
        const dateObj = new Date(partnerBirthday);
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear();
        return `${day}.${month}.${year}`;
      })()
    : "";

  useEffect(() => {
    const fetchPartnersOrders = async () => {
      try {
        const response = await fetch(`${apiUrl}/partner/${uniqueId}`, {
          credentials: "include", // Включите куки для авторизации
        });

        if (response.ok) {
          const data = await response.json(); // Преобразуем ответ в JSON

          // Функция сортировки
          const sortOrders = (orders, field = "order_date", order = "desc") => {
            return [...orders].sort((a, b) => {
              const fieldA = a[field];
              const fieldB = b[field];

              if (field.includes("date")) {
                return order === "desc"
                  ? new Date(fieldB) - new Date(fieldA)
                  : new Date(fieldA) - new Date(fieldB);
              }

              if (typeof fieldA === "number" && typeof fieldB === "number") {
                return order === "desc" ? fieldB - fieldA : fieldA - fieldB;
              }

              return order === "desc"
                ? fieldB.toString().localeCompare(fieldA.toString())
                : fieldA.toString().localeCompare(fieldB.toString());
            });
          };

          // Сортируем заказы перед сохранением в стейт
          const sortedOrders = sortOrders(
            data.orders || [],
            "order_date",
            "desc"
          );

          // Обновляем состояние на основе полученных данных
          setOrders(sortedOrders);
          setTotalSum(data.total_sum);
          setPromoCode(data.promo_code);
          setName(data.partner_name);
          setEmail(data.partner_email);
          setPartnerDateAdded(data.date_added || "");
          setPayoutPercentage(data.payout_percentage);
          setTotalPaidOrders(data.total_paid_orders);
          setTotalUnpaidOrders(data.total_unpaid_orders);
          setStatusPartners(data.partner_status);
          setPaidSum(data.paid_sum);
          setPartnerAddress(data.partner_address || "");
          setPartnerBirthday(data.partner_birthday || "");
          setPartnerPhone(data.partner_phone || "");
          setPartnerNote(data.partner_note || "");
          setUnpaidSum(data.unpaid_sum);
        } else {
          console.error("Ошибка при получении данных");
        }
      } catch (error) {
        console.error("Ошибка соединения с сервером:", error);
      }
    };

    fetchPartnersOrders();
  }, [apiUrl, uniqueId]); // Вызывается при изменении uniqueId

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/admin/partner/${uniqueId}/payment-history`,
          { credentials: "include" }
        );
        if (!response.ok) {
          console.error("Не удалось получить историю выплат");
          return;
        }
        const data = await response.json();
        const history = Array.isArray(data.history) ? data.history : [];
        const sortedHistory = [...history].sort((a, b) => {
          const dateA = new Date(a.payment_date || a.order_date || 0);
          const dateB = new Date(b.payment_date || b.order_date || 0);
          return dateB - dateA;
        });
        setPaymentHistory(sortedHistory);
        setFilteredPayments(sortedHistory);
      } catch (error) {
        console.error("Ошибка при загрузке истории выплат:", error);
      }
    };

    if (uniqueId) {
      fetchPaymentHistory();
    }
  }, [apiUrl, uniqueId]);


  const unmarkAsPaid = (orderId) => {
    fetch(`${apiUrl}/admin/partner/order/${orderId}/unpay`, {
      method: "POST",
      credentials: "include",
    })
      .then((response) => response.json())
      .then(() => {
        // Обновляем историю выплат
        setPaymentHistory((prevHistory) =>
          prevHistory.filter((payment) => payment.order_id !== orderId)
        );

        // Обновляем отфильтрованные данные
        setFilteredPayments((prevFiltered) =>
          prevFiltered.filter((payment) => payment.order_id !== orderId)
        );

        // Можно также обновить счетчики или другие данные при необходимости
      })
      .catch((error) => {
        alert("Ошибка при отмене выплаты");
        console.error(error);
      });
  };

  const sortOrders = (field) => {
    const order =
      ordersSortField === field && ordersSortOrder === "asc" ? "desc" : "asc";
    setOrdersSortField(field);
    setOrdersSortOrder(order);

    const sortedOrders = [...orders].sort((a, b) => {
      const fieldA = a[field] || ""; // Если null, заменяем на ""
      const fieldB = b[field] || "";

      if (field === "order_date" || field === "payment_date") {
        return order === "desc"
          ? new Date(fieldB || 0) - new Date(fieldA || 0) // Приводим пустые к 0
          : new Date(fieldA || 0) - new Date(fieldB || 0);
      }

      if (typeof fieldA === "number" && typeof fieldB === "number") {
        return order === "desc" ? fieldB - fieldA : fieldA - fieldB;
      }

      return order === "desc"
        ? fieldB.toString().localeCompare(fieldA.toString())
        : fieldA.toString().localeCompare(fieldB.toString());
    });

    setOrders(sortedOrders);
  };

  const sortPayments = (field) => {
    const order =
      paymentsSortField === field && paymentsSortOrder === "asc"
        ? "desc"
        : "asc";
    setPaymentsSortField(field);
    setPaymentsSortOrder(order);

    const sortedPayments = [...paymentHistory].sort((a, b) => {
      const aValue = a[field] || "";
      const bValue = b[field] || "";

      if (field === "payment_date" || field === "order_date") {
        return order === "asc"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }

      return order === "asc"
        ? aValue.toString().localeCompare(bValue.toString())
        : bValue.toString().localeCompare(aValue.toString());
    });

    setFilteredPayments(sortedPayments);
  };
  const navigate = useNavigate();
  // 🔹 Проверяем, имеет ли пользователь доступ
  const isAdmin = hasRole(["admin", "manager"]);
  const isOwner = user?.partnerUniqueId === uniqueId;
  // 🔥 Если нет доступа, показываем ошибку и кнопку возврата
  if (!isAdmin && !isOwner) {
    return (
      <Container className="page-loader text-center">
        <Alert variant="danger" className="shadow-sm">У вас нет доступа к этой странице!</Alert>
        <Button className="mt-3 btn-rounded" onClick={() => navigate("/dashboard")}>
          Вернуться в Dashboard
        </Button>
      </Container>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const fmtCurrency = (value) =>
    new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value) || 0);
  const fmtNumber = (value) => new Intl.NumberFormat("ru-RU").format(Number(value) || 0);
  const totalOrdersCount = Number(totalPaidOrders + totalUnpaidOrders) || 0;
  const averageCheck = totalOrdersCount ? (Number(totalSum) || 0) / totalOrdersCount : 0;
  const displayStatus = partnerStatus || "STARTER";
  const payoutProgress = totalSum ? Math.round((paidSum / totalSum) * 100) : 0;
  const totalVolume = Number(totalSum) || 0;
  const remainingOrders = Math.max(0, Number(totalUnpaidOrders) || 0);
  const tierRoadmap = [
    { name: "STARTER", limit: 3000 },
    { name: "SILVER", limit: 30000 },
    { name: "GOLD", limit: Infinity },
  ];
  const statusIndex = tierRoadmap.findIndex((tier) => tier.name === displayStatus);
  const fallbackTierIndex = tierRoadmap.findIndex((tier) => totalVolume < tier.limit);
  const currentTierIndex =
    statusIndex >= 0
      ? statusIndex
      : fallbackTierIndex >= 0
      ? fallbackTierIndex
      : tierRoadmap.length - 1;
  const nextTier = tierRoadmap[currentTierIndex + 1];
  const currentTierFloor = currentTierIndex === 0 ? 0 : tierRoadmap[currentTierIndex - 1].limit;
  const nextTierInfo =
    nextTier && nextTier.limit !== Infinity
      ? {
          name: nextTier.name,
          remaining: Math.max(0, nextTier.limit - totalVolume),
        }
      : null;
  const heroStats = [
    {
      label: "Сумма заказов",
      value: `${fmtCurrency(totalSum)} EUR`,
      hint: `Всего заказов ${fmtNumber(totalOrdersCount)}`,
    },
    {
      label: "Сумма к выплате",
      value: `${fmtCurrency(unpaidSum)} EUR`,
      hint: `Ожидает ${fmtNumber(totalUnpaidOrders)} заказов`,
    },
    {
      label: "Выплачено",
      value: `${fmtCurrency(paidSum)} EUR`,
      hint: `Оплачено ${fmtNumber(totalPaidOrders)} заказов`,
    },
    {
      label: "Средний чек",
      value: `${fmtCurrency(averageCheck)} EUR`,
      hint: "За весь период",
    },
  ];

  return (
    <Container fluid="xl" className="compact py-3">
      <section className="hero-board">
        <article className="hero-card hero-card--mosaic">
          <div className="hero-head">
            <div>
              <p className="eyebrow text-muted mb-1">Личный кабинет</p>
              <h1 className="hero-heading mb-1">{partnerName || "Карточка партнёра"}</h1>
              <div className="hero-email">{partnerEmail || "—"}</div>
              <div className="hero-date">
                <span className="hero-date__label">Дата регистрации</span>
                <span className="hero-date__value">{formatDateTime(dateAdded, true) || "—"}</span>
              </div>
            </div>
            <div className="hero-head__status">
              <div className="hero-badges">
                <span className="hero-pill">{displayStatus}</span>
                <span className="hero-pill hero-pill--rate">
                  {payoutPercentage ? `${payoutPercentage}%` : "—"}
                </span>
              </div>
              <div className="hero-head__promo">
                <span className="hero-head__label">Промокод</span>
                <span className="hero-head__value">{promoCode || "—"}</span>
              </div>
            </div>
          </div>
          <div className="hero-bar">
            {heroStats.map((stat) => (
              <div className="hero-bar__item" key={stat.label}>
                <span className="hero-bar__label">{stat.label}</span>
                <span className="hero-bar__value">{stat.value}</span>
                <span className="hero-bar__hint">{stat.hint}</span>
              </div>
            ))}
          </div>
        </article>
      </section>

      <div className="content-grid">
        <div className="content-main">
          <section className="panel panel--table">
            <div className="panel-header">
              <div>
                <p className="eyebrow text-muted mb-1">Все операции</p>
                <h2 className="h5 mb-0">Заказы партнёра</h2>
              </div>
              <Button variant="outline-secondary" className="btn-ghost btn-rounded" onClick={() => setShowHistoryModal(true)}>
                История выплат
              </Button>
            </div>
            <div className="table-wrap">
              <Table responsive className="table-enterprise mb-0">
                <thead>
                  <tr>
                    <th onClick={() => sortOrders("order_date")} style={{ cursor: "pointer" }}>
                      Дата создания сделки{" "}
                      {ordersSortField === "order_date" &&
                        (ordersSortOrder === "asc" ? <FaAngleUp /> : <FaAngleDown />)}
                    </th>
                    <th onClick={() => sortOrders("payment_date")} style={{ cursor: "pointer" }}>
                      Дата оплаты
                      {ordersSortField === "payment_date" &&
                        (ordersSortOrder === "asc" ? <FaAngleUp /> : <FaAngleDown />)}
                    </th>
                    <th onClick={() => sortOrders("partner_id")} style={{ cursor: "pointer" }}>
                      ID клиента{" "}
                      {ordersSortField === "partner_id" &&
                        (ordersSortOrder === "asc" ? <FaAngleUp /> : <FaAngleDown />)}
                    </th>
                    <th onClick={() => sortOrders("order_amount")} style={{ cursor: "pointer" }}>
                      Заказ на сумму{" "}
                      {ordersSortField === "order_amount" &&
                        (ordersSortOrder === "asc" ? <FaAngleUp /> : <FaAngleDown />)}
                    </th>
                    <th onClick={() => sortOrders("payout")} style={{ cursor: "pointer" }}>
                      Сумма к выплате{" "}
                      {ordersSortField === "payout" &&
                        (ordersSortOrder === "asc" ? <FaAngleUp /> : <FaAngleDown />)}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentOrders.map((order) => (
                    <tr key={order.id}>
                      <td>{formatDateTime(order.order_date, true)}</td>
                      <td>{formatDateTime(order.payment_date, false)}</td>
                      <td>{order.partner_id}</td>
                      <td>{fmtCurrency(order.order_amount)} €</td>
                      <td className="td-num">{order.payout.toFixed(2)} €</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <PaginationComponent
              currentPage={ordersCurrentPage}
              totalItems={filteredOrders.length}
              itemsPerPage={ordersPerPage}
              onPageChange={(page) => setOrdersCurrentPage(page)}
              onItemsPerPageChange={(items) => setOrdersPerPage(items)}
            />
          </section>
        </div>

        <aside className="content-side">
          <section className="panel panel--tiers">
            <div className="tier-widget">
              <div className="tier-widget__header">
                <div>
                  <p className="eyebrow text-muted mb-1">Дорожка статусов</p>
                  <h3 className="h6 mb-0">
                    {nextTierInfo ? `Путь к ${nextTierInfo.name}` : "Максимальный уровень"}
                  </h3>
                </div>
                <span className={`chip ${nextTierInfo ? "chip-ghost" : "chip-gold"}`}>
                  {nextTierInfo ? `Осталось ${fmtCurrency(nextTierInfo.remaining)} EUR` : "GOLD"}
                </span>
              </div>
              <div className="tier-ladder">
                {tierRoadmap.map((tier, idx) => {
                  const floor = idx === 0 ? 0 : tierRoadmap[idx - 1].limit;
                  const cap = tier.limit;
                  const isCurrent = idx === currentTierIndex;
                  const isLastTier = cap === Infinity;
                  const isComplete = totalVolume >= cap && !isLastTier;
                  let progressWidth = 0;

                  if (isCurrent) {
                    if (isLastTier) {
                      progressWidth = 100;
                    } else {
                      const currentGain = Math.min(
                        Math.max(totalVolume - floor, 0),
                        Math.max(cap - floor, 1)
                      );
                      progressWidth = Math.round(
                        (currentGain / Math.max(cap - floor, 1)) * 100
                      );
                    }
                  } else if (isComplete) {
                    progressWidth = 100;
                  }

                  const rangeLabel =
                    cap === Infinity
                      ? `${fmtCurrency(floor)}+ EUR`
                      : `${fmtCurrency(floor)} — ${fmtCurrency(cap)} EUR`;

                  let hint = "Будет открыт позже";
                  if (isCurrent && !isLastTier) {
                    hint = `Осталось ${fmtCurrency(Math.max(0, cap - totalVolume))} EUR`;
                  } else if (isCurrent && isLastTier) {
                    hint = "Вы на максимальном уровне";
                  } else if (isComplete) {
                    hint = "Статус получен";
                  }

                  return (
                    <div
                      key={tier.name}
                      className={`tier-step ${isCurrent ? "is-active" : ""} ${
                        isComplete ? "is-complete" : ""
                      }`}
                    >
                      <div className="tier-step__badge">{tier.name}</div>
                      {isCurrent && <div className="tier-step__percent">{progressWidth}%</div>}
                      <div className="tier-step__range">{rangeLabel}</div>
                      <div className="tier-progress-bar">
                        <div className="tier-progress-thumb" style={{ width: `${progressWidth}%` }} />
                      </div>
                      <div className="tier-step__hint">{hint}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </aside>
      </div>

      <HistoryModal
        showHistoryModal={showHistoryModal}
        closeHistoryModal={() => setShowHistoryModal(false)}
        dateInputs={dateInputs}
        setDateInputs={setDateInputs}
        setFilterDates={setFilterDates}
        filterDates={filterDates}
        setFilteredPayments={setFilteredPayments}
        paymentHistory={paymentHistory}
        currentPayments={currentPayments}
        sortPayments={sortPayments}
        paymentsSortField={paymentsSortField}
        paymentsSortOrder={paymentsSortOrder}
        unmarkAsPaid={unmarkAsPaid}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
    </Container>
  );
}

export default PartnerOrders;
